<li class="email" [class.selected]="selected()">
  <div
    class="email-card"
    role="button"
    tabindex="0"
    (click)="onSelectNotification()"
    (keydown)="onCardKeydown($event)"
  >
    <div>
      <p class="pg-medium">{{ notification().title }}</p>

      <p class="pg-small-regular">{{ notification().body }}</p>

      <p class="pg-mini-regular">
        {{ notification().createdAt | relativeTime }}
      </p>
    </div>

    @if (!notification().isRead) {
      <div class="actions">
        <span class="mark-read-btn">
          <umss-icon-button
            variant="Ghost"
            iconName="phosphorCheck"
            [umssTooltip]="'Mark as read'"
            (onClick)="onMarkAsRead($event)"
          />
        </span>
        <span class="not_read"> </span>
      </div>
    }
  </div>
</li>
